const isDevelopment = process.env.NODE_ENV === 'development';

// Función para suprimir la advertencia de React DevTools
const suppressDevToolsWarning = () => {
  if (typeof window !== 'undefined') {
    // Guardar la función original de console.warn
    const originalConsoleWarn = console.warn;
    
    // Sobrescribir console.warn
    console.warn = function(...args) {
      // Verificar si el mensaje es la advertencia de React DevTools
      if (args.length > 0 && 
          typeof args[0] === 'string' && 
          (args[0].includes('Download the React DevTools') || 
           args[0].includes('react.dev/link/react-devtools'))) {
        return;
      }
      // Si no es la advertencia, llamar a la función original
      originalConsoleWarn.apply(console, args);
    };

    // También intentar suprimir el mensaje a nivel de window
    if (window.console) {
      const originalWindowConsoleWarn = window.console.warn;
      window.console.warn = function(...args) {
        if (args.length > 0 && 
            typeof args[0] === 'string' && 
            (args[0].includes('Download the React DevTools') || 
             args[0].includes('react.dev/link/react-devtools'))) {
          return;
        }
        originalWindowConsoleWarn.apply(window.console, args);
      };
    }
  }
};

// Inicializar la supresión de la advertencia inmediatamente
suppressDevToolsWarning();

// También intentar suprimir el mensaje cuando el DOM esté listo
if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', suppressDevToolsWarning);
}

export const logger = {
  info: (component: string, message: string, data?: any) => {
    if (isDevelopment) {
      console.log(`[${component}] ${message}`, data || '');
    }
  },

  error: (component: string, message: string, error?: any) => {
    if (isDevelopment) {
      console.error(`[${component}] ${message}`, error || '');
    }
  },

  warn: (component: string, message: string, data?: any) => {
    if (isDevelopment) {
      console.warn(`[${component}] ${message}`, data || '');
    }
  },

  // Método para reinicializar la supresión de la advertencia
  reinitializeDevToolsWarning: () => {
    suppressDevToolsWarning();
  }
}; 